module.exports = __webpack_public_path__ + "img/logo_cerca.7463bfb4.jpg";